export default "__VITE_ASSET__c5f07043__"